module.exports = __webpack_public_path__ + "img/promoteur-maisonier.1051d416.webp";